import { $isHeadingNode, HeadingNode } from '@lexical/rich-text';
import { $isTextNode, ParagraphNode } from 'lexical';
import { $isCustomHeadingNode, CustomHeadingNode } from 'modules/Lexical/nodes/CustomHeadingNode';
import { $isCustomParagraphNode, CustomParagraphNode } from 'modules/Lexical/nodes/CustomParagraphNode';
import { NoWrapNode } from 'modules/Lexical/nodes/NoWrapNode/NoWrapNode';
import * as Constants from 'const';
import { ParagraphType } from 'services/ArtboardConverter/constants';
import { Schemas } from 'services/ArtboardConverter/models';
import { toPx } from 'utils/toPx';
import { ArtboardConverterStyles } from '../convertLexicalEditorState';
import { getParagraphAlign, getParagraphAnchor, getParagraphFontSize, getParagraphLineHeight } from './Paragraph';

type Context = {
  projectType: Constants.ProjectType;
  lineheightNoPx?: boolean;
};

type NodeType = ParagraphNode | CustomParagraphNode | NoWrapNode | HeadingNode | CustomHeadingNode;

function $hasLineHeightAndFontSize(node: NodeType): node is CustomParagraphNode | CustomHeadingNode {
  return $isCustomParagraphNode(node) || $isCustomHeadingNode(node);
}

export function createParagraphForText(
  node: NodeType,
  context: Context,
  converterStyles: ArtboardConverterStyles,
  segments: Schemas.Segment[],
): Schemas.TextParagraph {
  const { projectType, lineheightNoPx } = context;

  const firstTextNode = node.getChildren().find($isTextNode);
  const defaultFontSize = ($hasLineHeightAndFontSize(node) ? node.getFontSize() : converterStyles.fontSize) ?? converterStyles.fontSize;
  const fontSizeNumber = getParagraphFontSize(firstTextNode, defaultFontSize, projectType);
  const lineHeight = ($hasLineHeightAndFontSize(node)) ? node.getLineHeight() : undefined;

  let type = ParagraphType.PLAINT_TEXT;
  let tag: Constants.HeadingTagType | undefined;

  if ($isHeadingNode(node)) {
    type = ParagraphType.HEADING_TEXT;
    tag = node.getTag();
  }

  return {
    type,
    align: getParagraphAlign(node.getFormatType(), converterStyles.paragraphAlign),
    anchor: getParagraphAnchor(node),
    color: converterStyles.color,
    fontFamily: converterStyles.fontFamily,
    fontSize: toPx(fontSizeNumber),
    lineHeight: getParagraphLineHeight(lineHeight, fontSizeNumber, converterStyles.lineHeight, lineheightNoPx),
    segments,
    tag,
  };
}
